// src/api/auth.js
import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8082";
const BASE_URL = `${API_BASE}/api`;

// client tanpa token (untuk login)
const publicClient = axios.create({
  baseURL: BASE_URL,
});

/**
 * POST /api/login
 * body: { username, password }
 * return: { token, user }
 */
export async function loginApi(username, password) {
  const res = await publicClient.post("/login", { username, password });
  return res.data;
}

/**
 * client dengan Authorization Bearer <token>
 * onUnauthorized: callback yang dipanggil ketika token expired (401)
 */
export function createAuthClient(token, onUnauthorized) {
  const client = axios.create({
    baseURL: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // Interceptor: tangkap 401 → otomatis logout
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        if (onUnauthorized) onUnauthorized();
      }
      return Promise.reject(error);
    }
  );

  return client;
}